import React from 'react';
import {Controller} from "react-hook-form";
import {browserLanguages} from "../../utils/DataList";
import {Autocomplete, Box, Checkbox, Chip, TextField} from "@mui/material";
import {CheckBox, CheckBoxOutlineBlank} from "@mui/icons-material";

const icon = <CheckBoxOutlineBlank fontSize="small"/>;
const checkedIcon = <CheckBox fontSize="small"/>;

export default function BrowserLanguageMultiSelect(props) {
    const {
        control,
        inputLabel = "Select browser language",
        inputName = "browserLang",
        updateOnChange = () => null,
        outputKey = null // OPTIONAL: set to "code", "language" or leave null for full object
    } = props;

    return (
        <Controller
            name={inputName}
            control={control}
            defaultValue={[]}
            render={({field: {onChange, value, ...fieldProps}}) => {

                // TRANSFORM VALUE FOR UI: Map stored values back to full objects
                const safeValue = Array.isArray(value)
                    ? value.map((item) => {
                        if (typeof item !== 'object') {
                            // Find matching object by the specified outputKey (fallback to 'code')
                            return browserLanguages.find((lang) => lang[outputKey || 'code'] === item);
                        }
                        return item;
                    }).filter(Boolean)
                    : [];

                return (
                    <Autocomplete
                        multiple
                        disableCloseOnSelect={true}
                        id="browser-language-multi-select"
                        isOptionEqualToValue={(option, val) => option?.code === val?.code || option?.language === val?.language}
                        getOptionLabel={(option) => option?.language || ""}
                        options={browserLanguages}
                        value={safeValue}
                        renderOption={(renderProps, option, {selected, index}) => (
                            <li {...renderProps} key={`${option?.code || 'lang'}-${index}`}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    sx={{mr: 1}}
                                    checked={selected}
                                    color="primary"
                                />
                                {option.language}
                            </li>
                        )}
                        renderValue={(selected, getTagProps) =>
                            selected?.map((option, index) => {
                                const {key, ...tagProps} = getTagProps({index});
                                return (
                                    <Chip
                                        key={key}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        label={option?.language || option}
                                        {...tagProps}
                                    />
                                );
                            })
                        }
                        renderInput={(params) => (
                            <Box display="flex">
                                <Box flexGrow={1}>
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        margin="dense"
                                        size="small"
                                        label={inputLabel}
                                    />
                                </Box>
                            </Box>
                        )}
                        onChange={(e, data) => {
                            // TRANSFORM DATA ON CHANGE:
                            const processedData = outputKey && Array.isArray(data)
                                ? data.map(item => typeof item === 'object' ? item[outputKey] : item).filter(Boolean)
                                : data || [];

                            onChange(processedData);
                            updateOnChange(processedData);
                        }}
                        {...fieldProps}
                    />
                );
            }}
        />
    );
}
